import http from './api';

const login = options => http.post('api/agent/login', {}, options);
const currentUserInfo = () => http.get('api/agent/current');

export default {
  login,
  currentUserInfo
};
